import Footer from '../layout/Footer';
import TextSlider from '../pages/home/TextSlider';
import Header from '../layout/Header';
import { useLocation } from 'react-router-dom';
import Chatbot from '../Chatbot/Chatbot';

const Layout = (props) => {
  const location = useLocation()
  return (
    <>
      <Header />
      {location.pathname !== '/home' && <TextSlider />}
      <main>
        {props.children}
        <Chatbot />
      </main>
      <Footer />
    </>
  )
}

export default Layout;